import { IOrder } from 'commons/types/order';
import { TYPE_STATUS_ITEM } from 'commons/types';

export const OrderMock: IOrder = {
  id: '22',
  agencyId: 1,
  agencyName: 'STELAR PRODUCOES ARTISTICAS LTDA ME',
  script: 401,
  orderDate: '2023-08-28T10:36:13+00:00',
  content: 'FUZUE',
  startRecordingDate: '2023-08-29T10:36:13+00:00',
  recordingPlace: 'APTO BEBEL',
  statusProdutorExecutivo: 1,
  items: [
    {
      id: '32',
      status: TYPE_STATUS_ITEM.AWAITING,
      startRecordingTime: '2023-09-01T16:00:00+00:00',
      endingRecordingTime: '2023-09-01T21:00:00+00:00',
      startRecordingDate: '2023-09-01T16:00:00+00:00',
      endingRecordingDate: '2023-09-01T21:00:00+00:00',
      arrivedTime: '2023-08-28T05:05:01+00:00',
      type: 'Adulto',
      amount: 1,
      agencyId: '',
      orderId: 222,
      script: 401,
      userLoggedEmail: 'email@test',
      userLoggedName: 'usuario',
    },
  ],
};

export const OrderPDFMock = {
  id: '2131',
  content: 'PANTANAL',
  agency: {
    name: 'POOLLL',
  },
  quantityRequested: 2,
  figurantType: 'ADULTO',
  dailyValue: 200,
  presentation: {
    date: '22/10/2023',
    place: 'Globo A',
    address: 'ESTUDIO',
  },
  recording: {
    date: '22/10/2023',
    place: 'Globo B',
  },
  figurants: [
    {
      id: '13213',
      name: 'ARTHUR',
      document: '312312312',
      numberAccess: '131',
    },
    {
      id: '1323',
      name: 'ARTHUR 1',
      document: '312321312312',
      numberAccess: '131',
    },
    {
      id: '13233',
      name: 'ARTHUR 2',
      document: '1231123354',
      numberAccess: '131',
    },
    {
      id: '13243',
      name: 'ARTHUR 3',
      document: '1231233354',
      numberAccess: '131',
    },
    {
      id: '13123',
      name: 'ARTHUR 4',
      document: '1231232354',
      numberAccess: '131',
    },
    {
      id: '132423',
      name: 'ARTHUR 5',
      document: '1231233354',
      numberAccess: '131',
    },
    {
      id: '13133',
      name: 'ARTHUR 6',
      document: '12312332354',
      numberAccess: '131',
    },
    {
      id: '131333',
      name: 'ARTHUR 7',
      document: '12312323524',
      numberAccess: '131',
    },
  ],
};

export const OrdersMock: IOrder[] = [OrderMock, OrderMock, OrderMock];
